<div class="container-fluid" *ngIf="item">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Products Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item"><a routerLink="/ecomm/products">Products</a></li>
            <li class="breadcrumb-item active">{{ isEditMode ? 'Edit' : 'View' }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{ isEditMode ? 'Edit Product' : 'Product Details' }}</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/products" class="btn btn-light me-2">Back to List</a>
            <ng-container *ngIf="!isEditMode">
              <button type="button" class="btn btn-primary" (click)="startEdit()">Edit</button>
            </ng-container>
            <ng-container *ngIf="isEditMode">
              <button type="button" class="btn btn-light me-2" (click)="cancelEdit()">Back</button>
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </ng-container>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4" *ngIf="!isEditMode">
            <div class="col-xxl-6 col-md-6"><label class="form-label">ID</label><input class="form-control" [value]="item.id" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Name</label><input class="form-control" [value]="item.name" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Brand</label><input class="form-control" [value]="item.brand?.name || item.brand_id" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Category</label><input class="form-control" [value]="categoryNames()" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Group</label><input class="form-control" [value]="item.group?.name || item.group_id || '-'" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Stock ID</label><input class="form-control" [value]="item.stock_id" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Barcode</label><input class="form-control" [value]="item.barcode" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">SKU</label><input class="form-control" [value]="item.sku" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Base Price</label><input class="form-control" [value]="item.base_price" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Status</label><input class="form-control" [value]="statusLabel(item.status)" readonly></div>
            <div class="col-12"><label class="form-label">Description</label><textarea class="form-control" rows="3" [value]="item.description || '-'" readonly></textarea></div>
            <div class="col-12"><label class="form-label">Special Remarks</label><textarea class="form-control" rows="2" [value]="item.special_remarks || '-'" readonly></textarea></div>
          </div>

          <div class="row gy-4" *ngIf="isEditMode">
            <div class="col-xxl-6 col-md-6"><label class="form-label">ID</label><input class="form-control" [value]="item.id" readonly></div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input class="form-control" name="name" [(ngModel)]="form.name" [ngClass]="{'is-invalid': !form.name && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Brand <span class="text-danger">*</span></label>
              <select class="form-select" name="brand_id" [(ngModel)]="form.brand_id" [ngClass]="{'is-invalid': !form.brand_id && validationTriggered}">
                <option *ngFor="let brand of brands" [ngValue]="brand.id">{{ brand.name }}</option>
              </select>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Category</label>
              <select class="form-select" name="category_key" [(ngModel)]="form.category_key">
                <option value="">Select category</option>
                <optgroup label="Categories" *ngIf="categories.length">
                  <option *ngFor="let category of categories" [ngValue]="'c:' + category.id">{{ category.name }}</option>
                </optgroup>
                <optgroup label="SAP Categories" *ngIf="sapCategories.length">
                  <option *ngFor="let category of sapCategories" [ngValue]="'s:' + category.id">{{ category.name }}</option>
                </optgroup>
              </select>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Group ID</label>
              <input type="number" class="form-control" name="group_id" [(ngModel)]="form.group_id">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Stock ID <span class="text-danger">*</span></label>
              <input class="form-control" name="stock_id" [(ngModel)]="form.stock_id" [ngClass]="{'is-invalid': !form.stock_id && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Barcode <span class="text-danger">*</span></label>
              <input class="form-control" name="barcode" [(ngModel)]="form.barcode" [ngClass]="{'is-invalid': !form.barcode && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">SKU <span class="text-danger">*</span></label>
              <input class="form-control" name="sku" [(ngModel)]="form.sku" [ngClass]="{'is-invalid': !form.sku && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Base Price <span class="text-danger">*</span></label>
              <input type="number" step="0.01" class="form-control" name="base_price" [(ngModel)]="form.base_price" [ngClass]="{'is-invalid': (form.base_price === '' || form.base_price === null) && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Status <span class="text-danger">*</span></label>
              <select class="form-select" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label">Description</label>
              <textarea class="form-control" name="description" rows="3" [(ngModel)]="form.description"></textarea>
            </div>
            <div class="col-12">
              <label class="form-label">Special Remarks</label>
              <textarea class="form-control" name="special_remarks" rows="2" [(ngModel)]="form.special_remarks"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
